import React from "react";
import { NotesForm } from "..";

var CheckoutNotes = function CheckoutNotes(_ref) {
  var formId = _ref.formId,
      formRef = _ref.formRef,
      notes = _ref.notes,
      setNotes = _ref.setNotes,
      errors = _ref.errors,
      noteFields = _ref.noteFields;
  return React.createElement("section", null, React.createElement(NotesForm, {
    noteFields: noteFields,
    formId: formId,
    formRef: formRef,
    notes: notes,
    handleSubmit: setNotes,
    errors: errors
  }));
};

CheckoutNotes.displayName = "CheckoutNotes";
export { CheckoutNotes };